import { SET_STICKY } from 'actions/header';

export default (state = { sticky: true }, action) => {
    switch (action.type) {
        case SET_STICKY:
            return {sticky: action.payload};
    }

    return state;
}
